// components/ServicesSection/ServiceCard.jsx
import React from "react";
import "./ServicesSection.css";
import navision from "../../assets/images/navision.png"; // Import the logo image

const ServiceCard = ({ icon: Icon, title, description, featured, logo }) => {
  return (
    <div className={`service-card ${featured ? "featured-service" : ""}`}>
      <div
        className={`service-card-icon-wrapper ${
          featured ? "featured-icon" : ""
        }`}
      >
        {Icon && <Icon className="service-card-icon" />}
        {/* <Icon className="service-card-icon" /> */}
        {logo && (
          <img
            src={logo}
            alt={`${title} logo`}
            className="service-card-icon"
            loading="lazy"
          />
        )}
      </div>
      <h3 className="service-card-title">{title}</h3>
      <p className="service-card-description">{description}</p>
      {featured && <div className="featured-badge">Flagship Solution</div>}
    </div>
  );
};

export default ServiceCard;
